import { UserProfile } from '@dynamic-labs/sdk-react-core';
import { useMemo } from 'react';

/**
 * Custom hook to get the most recently selected wallet with avatars.
 * @function useMostRecentlySelectedWalletWithAvatars
 * @param {string[]} avatarWallets - The list of avatar wallet addresses.
 * @param {UserProfile | undefined} user - The user profile.
 * @returns {string | undefined} The address of the most recently selected wallet with avatars, or undefined if not found.
 */
export const useMostRecentlySelectedWalletWithAvatars = (
  avatarWallets: string[],
  user: UserProfile | undefined,
) => {
  return useMemo(() => {
    const sortedWallets = [...(user?.verifiedCredentials || [])]
      .filter((wallet) => wallet.lastSelectedAt)
      .sort((a, b) =>
        (b.lastSelectedAt ?? 0) > (a.lastSelectedAt ?? 0) ? 1 : -1,
      );

    return sortedWallets.find(
      (wallet) => wallet?.address && avatarWallets.includes(wallet.address),
    )?.address;
  }, [avatarWallets, user?.verifiedCredentials]);
};
